import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { portalAppTitleForPath } from './lib/portal';
import { installMobileViewportGuards } from './lib/mobileViewport';
import { migrateServiceWorkerIfNeeded, watchServiceWorkerUpdates } from './lib/webPush';
import App from './App';
import './styles/theme.css';
import './styles/calendar.css';

document.title = portalAppTitleForPath(window.location.pathname);

async function boot() {
  // May reload the page once to drop a stale caching service worker.
  if (await migrateServiceWorkerIfNeeded()) return;

  watchServiceWorkerUpdates();
  installMobileViewportGuards();

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void boot();
